/*
 * @Copyright:
 * -----------------------------------------------------------------------------------
 *  Kingsoft Office Enterprise Cloud Services.
 *  Copyright (c) Kingsoft Office,All rights reserved.
 * -----------------------------------------------------------------------------------
 *
 * @Date: 2020-08-24 17:51:03
 * @Author: Kaven.D
 * @LastEditors: Kaven.D
 * @LastEditTime: 2020-09-24 11:36:33
 * @Description:
 */
import { COMAPNYLIST, ADMINCOMAPNYLIST, ACTIVE_AMOUNT } from './constants'
export default {
  [COMAPNYLIST]: (state, v) => {
    state[COMAPNYLIST] = v
  },
  [ADMINCOMAPNYLIST]: (state, v) => {
    state[ADMINCOMAPNYLIST] = v
  },
  [ACTIVE_AMOUNT]: (state, v) => {
    state[ACTIVE_AMOUNT] = v
  },
}
